import { easiwareThemes } from 'shared/utils'

const { EASIWARE_DELIVERY_IN_APP } = easiwareThemes

const getEasiwareScriptInfo = (themeId: string) => {
    let formId = ''
    switch (themeId) {
        case EASIWARE_DELIVERY_IN_APP:
            formId = process.env.REACT_APP_EASIWARE_FORM_ID_DELIVERY || ''
            break
        default:
            formId = themeId
            break
    }
    return {
        formId,
        src: process.env.REACT_APP_EASIWARE_SRC || '',
        solutionId: process.env.REACT_APP_EASIWARE_SOLUTION_ID || ''
    }
}

const getEasiwareScript = (formId: string, solutionId: string) => `
        esw.forms.create({
            "solutionId": "${solutionId}",
            "formId": "${formId}",
            "language": "fr",
            "buildinelement": null
        });`

const getBotmindScript = (
    email: string,
    firstname: string,
    lastname: string,
    consentReceived: string
) => `
    window.botmindWidget = null;
    function initBotmindChat() {
      if (window.botmindWidget?.works && window.botmindWidget?.init) {
        window.botmindWidget.init(
          {
            token: '${process.env.REACT_APP_BOTMIND_TOKEN || ''}',
            host: 'https://api.widget.botmind.io',
            language: 'fr',
            consentReceived: ${consentReceived}
          },
          {
            email: '${email}',
            firstName: '${firstname}',
            lastName: '${lastname}'
          },
          {
            startHidden: true,
            v2: true
          }
        );
      }
    }

    function BCinitialize(i, t) {
      let n;
      i.getElementById(t)
        ? initBotmindChat()
        : (((n = i.createElement('script')).id = t),
          (n.async = !0),
          (n.src = 'https://widget.botmind.io' + '/public/widget.js'),
          (n.onload = initBotmindChat),
          i.head.appendChild(n));
    }

    function BCinitiateCall() {
      BCinitialize(document, 'botmind-webchat-js');
    }
    if (document.readyState === 'loading') {
      window.addEventListener
        ? window.addEventListener('load', BCinitiateCall, !1)
        : window.attachEvent('load', BCinitiateCall, !1);
    } else {
      BCinitiateCall();
    }`

export { getEasiwareScriptInfo, getEasiwareScript, getBotmindScript }
